import {DialogCallbacks} from 'types/common';
import api from 'api';
import types from '../types';
import {usePostApiDispatch} from 'common/hooks/usePostApiDispatch';

export const useLogoff = (cbs?: DialogCallbacks) =>
   usePostApiDispatch(api.logoff, types.LOGOFF, {
      data: {
         connections: [],
      },
      ...cbs,
   });
